export default __webpack_public_path__ + "static/media/icon-Settings.ab0648d7.svg";